import { forEach, get, set, merge } from 'lodash';

import { adaptV4Theme, createTheme as createMuiTheme } from '@mui/material/styles';
import { THEME_DEFAULTS, AGENT_DATA_TO_THEME_PATH_MAP } from 'common/constants/theme';

const themeAgent = (theme, customizations) => {
  forEach(Object.keys(AGENT_DATA_TO_THEME_PATH_MAP), key => {
    const path = AGENT_DATA_TO_THEME_PATH_MAP[key];
    if (key in customizations) {
      const value = customizations[key] == null ? get(THEME_DEFAULTS, path) : customizations[key];
      set(theme, path, value);
    } else {
      set(theme, path, get(THEME_DEFAULTS, path));
    }
  });
  return theme;
};

const createThemeAgent = customizations => {
  const typography = { fontFamily: customizations.primaryFont }; // Necessary on first createMuiTheme.
  let theme = createMuiTheme(adaptV4Theme(merge({}, THEME_DEFAULTS, { typography })));
  theme = themeAgent(theme, customizations);
  theme = createMuiTheme(adaptV4Theme(theme));
  return theme;
};

export { themeAgent };
export { createThemeAgent };
